var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7109 6H7.28906V25H22.7109V6Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1014 6C1.94079 6 1 6.97235 1 8.17188V22.8281C1 24.0276 1.94079 25 3.1014 25H7.28906V6H3.1014Z",
    fill: "#FF4B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8986 6H22.7109V25H26.8986C28.0592 25 29 24.0276 29 22.8281V8.17189C29 6.97235 28.0592 6 26.8986 6Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9256 17.2399L20.7903 15.6861L20.133 15.3741C19.9486 15.2865 19.8431 15.0976 19.8704 14.9036L20.0842 13.3814L18.8714 13.7163C18.6035 13.7904 18.3255 13.6339 18.2652 13.3753L18.1491 12.877L17.0103 14.1421C16.8525 14.3174 16.5517 14.1835 16.5929 13.9562L17.0792 11.2719L16.3346 11.4652C16.1172 11.5216 15.8875 11.4277 15.7814 11.2388L14.9974 9.84387V9.8418L14.9968 9.84284L14.9962 9.8418V9.84387L14.2122 11.2388C14.106 11.4276 13.8763 11.5216 13.6588 11.4652L12.9143 11.2719L13.4006 13.9562C13.4418 14.1835 13.141 14.3174 12.9831 14.1421L11.8444 12.877L11.7282 13.3754C11.6679 13.634 11.3899 13.7904 11.122 13.7164L9.9092 13.3815L10.1231 14.9036C10.1504 15.0976 10.0448 15.2866 9.86047 15.3741L9.20312 15.6861L12.0678 17.24C12.3646 17.4009 12.4946 17.7423 12.3749 18.0462L12.13 18.6679L14.5846 18.469C14.7205 18.458 14.8361 18.5618 14.8321 18.6911L14.7548 21.1852H15.2376L15.1601 18.691C15.1561 18.5617 15.2717 18.4579 15.4076 18.4689L17.8634 18.6679L17.6185 18.0462C17.4989 17.7423 17.6289 17.4008 17.9256 17.2399Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/CANADA.dd2e8e3ac7885b4f512826b68e757c4a.svg";
export { ForwardRef as ReactComponent };